module.exports = require("././angular-aria.js");


//////////////////
// WEBPACK FOOTER
// angular-aria (bower component)
// module id = 1078
// module chunks = 1